<template>
  <component
    :is="containerTag"
    :class="{
      'product-category-tile-fi': true,
      'product-category-tile-fi--teaser': category.Slug,
      'product-category-tile-fi--is-family-page-variant': isGuidedRecommandation,
      'product-category-tile-fi--has-badge': isGuidedRecommandation && category.familyProductCount,
    }"
    :href="categoryHref"
    @click.stop.prevent="goToCategory"
  >
    <div class="product-category-tile-fi__image">
      <ssr-cloud-image-fi
        v-if="category.image"
        class="product-category-tile-fi__img"
        :src="category.image"
        :alt="category.name"
        :breakpoints="breakpoints"
        :unlimited="unlimited"
        :aspect-ratio="16 / 9"
        trim
        params="func=fit"
      />
    </div>
    <template v-if="!isGuidedRecommandation">
      <div class="product-category-tile-fi__info">
        <div
          v-if="category.name"
          class="product-category-tile-fi__name"
        >
          {{ category.name }}
        </div>
        <div
          v-if="category.marketingClaim"
          class="product-category-tile-fi__claim"
        >
          {{ category.marketingClaim }}
        </div>
      </div>

      <div
        v-if="category.Slug"
        :class="{
          'fi-text-21': !isLG,
          'fi-text-24': isLG,
          'product-category-tile-fi__arrow': true,
          'fi-semibold': true,
        }"
      >
        <arrow-icon class="product-category-tile-fi__arrow-icon" />
      </div>
    </template>
    <template v-else>
      <div class="product-category-tile-fi__title">
        {{ category.name }}
      </div>
      <div
        v-if="category.familyProductCount"
        class="product-category-tile-fi__badge"
      >
        {{
          $dict.get(
            category.familyProductCount === '1'
              ? 'search.Variants-Singular'
              : 'search.Variants-Plural',
            [category.familyProductCount],
          )
        }}
      </div>
    </template>
  </component>
</template>

<script>
import { ArrowIcon, SsrCloudImageFi } from 'atoms';

import breakpointMixin from '@/mixins/breakpointMixin.vue';

export default {
  name: 'ProductCategoryTileFi',
  components: {
    ArrowIcon,
    SsrCloudImageFi,
  },
  mixins: [breakpointMixin],
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    isGuidedRecommandation: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tile-clicked'],
  data() {
    return {
      breakpoints: [
        {
          mediaWidth: 480,
          imageWidth: 331,
        },
        {
          mediaWidth: 767,
          imageWidth: 404,
        },
        {
          mediaWidth: 768,
          imageWidth: 256,
        },
        {
          mediaWidth: 1023,
          imageWidth: 361,
        },
        {
          mediaWidth: 1440,
          imageWidth: 300,
        },
        {
          mediaWidth: 1920,
          imageWidth: 300,
        },
      ],
      unlimited: 300,
    };
  },
  computed: {
    containerTag() {
      return this.category.Slug && !this.isEditMode ? 'a' : 'div';
    },
    categoryHref() {
      return this.category.Slug && !this.isEditMode
        ? this.$fischer.pages.products().url + this.category.Slug
        : null;
    },
  },
  methods: {
    goToCategory() {
      this.$emit('tile-clicked');

      if (this.isGuidedRecommandation) {
        try {
          localStorage.setItem(
            'recommendationClick',
            JSON.stringify({
              refererId: this.$fischer.catalogId(),
              guided: true,
            }),
          );
        } catch (error) {
          console.debug('failed to store recommendation click', error);
        }
      }

      window.location = this.categoryHref;
    },
  },
};
</script>

<style scoped src="./product-category-tile-fi" />
